import React, { useState, useEffect, useRef } from "react";
import { useSnapshot } from "valtio";
import { ViewState, MetadataState, Store, SelectionState } from "../store";
import upArrow from "../asset/up_arrow.svg";
import downArrow from "../asset/down_arrow.svg";

export const Filters = () => {
  const [showFilters, setShowFilters] = useState(false);
  const ViewSnap = useSnapshot(ViewState);
  const MetaSnap = useSnapshot(MetadataState);
  const [filters, setFilters] = useState({
    circ: false,
    drill: false,
    drain: false,
    pressure: false,
    booster: false,
    energy: false,
    water: false,
    stations: false,
  });

  const handleCheckboxChange = (key) => {
    let newFilters = { ...filters };

    if (key === "9") {
      newFilters = Object.keys(filters).reduce((acc, filterKey) => {
        acc[filterKey] = false;
        return acc;
      }, {});
      newFilters["9"] = true;
    } else {
      newFilters[key] = !newFilters[key];
      newFilters["9"] = false;
    }

    setFilters(newFilters);

    MetadataState.selectedTypes = Object.keys(newFilters).filter(
      (filterKey) => newFilters[filterKey]
    );
  };

  useEffect(() => {
    const newFilters = Object.keys(MetaSnap.pumpTypes).reduce((acc, key) => {
      acc[key] = MetaSnap.selectedTypes.includes(key);
      return acc;
    }, {});
    setFilters(newFilters);
  }, [MetaSnap.pumpTypes]);

  const defaultTexts = {
    general: {
      filters: "Filters",
      clearFilters: "Clear",
    },
    pumpTypes: {
      circ: "Circulators",
      drill: "Borehole- and wellpumps",
      drain: "Drainage- and sewage pumps",
      pressure: "Pressure booster pumps",
      booster: "Booster set",
      energy: "Energy meters",
      water: "Water meters",
      stations: "Pump stations",
    },
  };
  const filterBoxRef = useRef(null);

  const handleClickOutside = (event) => {
    if (filterBoxRef.current && !filterBoxRef.current.contains(event.target)) {
      setShowFilters(false);
    }
  };
  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);
  const selectedFilterCount = MetaSnap.selectedTypes.includes("9")
    ? 0
    : MetaSnap.selectedTypes.length;

  return (
    <div className="filterWrapper" ref={filterBoxRef}>
      <div className="filterBox" onClick={() => setShowFilters(!showFilters)}>
        <p style={{ fontSize: 14 }}>
          {MetaSnap.texts?.general?.productTypes || "Select product type(s)"}
          {selectedFilterCount > 0 ? ` : ${selectedFilterCount}` : ""}
        </p>

        {showFilters ? (
          <img src={upArrow} style={{ width: 9 }} />
        ) : (
          <img src={downArrow} style={{ width: 9 }} />
        )}
      </div>

      {showFilters && (
        <div className="filterList">
          {Object.entries(MetaSnap.pumpTypes)
            .sort((a, b) => {
              const numA = parseInt(a[0], 10);
              const numB = parseInt(b[0], 10);
              if (numA === 9) return -1;
              if (numB === 9) return 1;
              return numA - numB;
            })
            .map(([key, value], idx) => (
              <React.Fragment key={"pumpTypes" + key + "_" + idx}>
                <div className="filterDivWrapper">
                  <input
                    type="checkbox"
                    id={`checkbox-${key}`}
                    name={value}
                    className="filterCheckbox"
                    checked={!!filters[key]}
                    onChange={() => handleCheckboxChange(key)}
                    value={key}
                  />
                  <label htmlFor={`checkbox-${key}`} className="filterLabel">
                    {value || defaultTexts.pumpTypes[key]}
                  </label>
                </div>
              </React.Fragment>
            ))}
        </div>
      )}
    </div>
  );
};
